<template>
  <div id="chart">
    <div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="filter" id="filter1"
          @change="changeChart('bar')" checked
        >
        <label class="form-check-label" for="filter1">Bar Chart</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="filter" id="filter2"
          @change="changeChart('column')"
        >
        <label class="form-check-label" for="filter2">Column Chart</label>
      </div>
    </div>
    <apexchart type=bar :height="height" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
  import Vue from 'vue'
  import chartOptions from './chart-options'
  import VueApexCharts from 'vue-apexcharts'

  Vue.use(VueApexCharts)

  export default {
    components: {
      apexchart: VueApexCharts,
    },
    methods: {
      changeChart(type) {
        if (type === 'column') {
          // this.height = 800
          this.chartOptions = chartOptions.column
        } else {
          // this.height = 800
          this.chartOptions = chartOptions.bar
        }
      }
    },
    data() {
      return {
        series: window.series,
        horizontal: false,
        height: 800,
        chartOptions: chartOptions.bar
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/trials/TrialsChart.vue